import { inject, onActivated, onBeforeUnmount, onDeactivated, onMounted } from 'vue'

/**
 * Lift the app shell's default content max width (see Full.vue) while the
 * calling component is mounted and active, so wide grids can span to the
 * right edge. Handles keep-alive activation/deactivation.
 */
export function useFullWidthContent () {
  const requestFullWidthContent = inject<(() => () => void) | null>('requestFullWidthContent', null)
  let releaseFullWidthContent: (() => void) | null = null

  const enableFullWidthContent = () => {
    if (!releaseFullWidthContent && requestFullWidthContent) {
      releaseFullWidthContent = requestFullWidthContent()
    }
  }

  const disableFullWidthContent = () => {
    if (releaseFullWidthContent) {
      releaseFullWidthContent()
      releaseFullWidthContent = null
    }
  }

  onMounted(enableFullWidthContent)
  onActivated(enableFullWidthContent)
  onDeactivated(disableFullWidthContent)
  onBeforeUnmount(disableFullWidthContent)
}
